import React, { Component } from 'react';

export class PreviousSearches extends Component {
  render() {
    return (<div className="container">
      {this.props.items.map(i => <div key={i} className="previous-search-item badge badge-light mr-2"><span className="mr-2 clickable" onClick={() => this.props.onSelect(i)}>{i}</span><i className="fas fa-times  clickable" onClick={()=>this.props.onRemove(i)}></i></div>)}
    </div>);
  }
}